import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

/**
 * Value growth area chart — derives a 6-month series from the wallet's
 * initial and current value. Pure presentational.
 */
export function ValueGrowthChart({ wallet }) {
  const chartData = [
    { date: 'Jan', value: wallet?.initial_value || 0 },
    { date: 'Feb', value: (wallet?.initial_value || 0) * 1.02 },
    { date: 'Mar', value: (wallet?.initial_value || 0) * 1.05 },
    { date: 'Apr', value: (wallet?.initial_value || 0) * 1.03 },
    { date: 'May', value: (wallet?.initial_value || 0) * 1.08 },
    { date: 'Jun', value: wallet?.current_value || 0 },
  ];

  return (
    <Card className="bg-[#041A3B] border-white/10">
      <CardHeader>
        <CardTitle className="font-outfit text-white">Value Growth</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={chartData}>
              <defs>
                <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#00E5FF" stopOpacity={0.3} />
                  <stop offset="95%" stopColor="#00E5FF" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
              <XAxis dataKey="date" stroke="#5C7599" />
              <YAxis stroke="#5C7599" />
              <Tooltip
                contentStyle={{ backgroundColor: '#041A3B', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px' }}
                labelStyle={{ color: '#A0B4CC' }}
                itemStyle={{ color: '#00E5FF' }}
              />
              <Area type="monotone" dataKey="value" stroke="#00E5FF" fillOpacity={1} fill="url(#colorValue)" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
